import {Component,OnInit} from '@angular/core';
import {PageHeaderItem} from "@share/component/page-header/page-header";
import {Router} from "@angular/router";
import {TabUtils} from "@share/utils/tab-utils";

/**
 * Enumération des onglets
 */
export enum Onglets {
    OMP = "Omp",
    OM = "Om",
    DV = "Dv",
    NDF = "Ndf",
    AVANCE = "Avance",
    FACTURE = "Facture",
}

/**
 * Composant d'affichage de la page Formulaire
 *
 * @author Lionel Gimenez
 * @date 04/09/2025
 */
@Component({
    host: {'data-test-id': 'parametre-formulaire'},
    templateUrl: './parametre-formulaire.component.html'
})
export class ParametreFormulaireComponent implements OnInit {
    /** Liste statique des onglets */
    public static listeOnglets: Array<PageHeaderItem> = [
        {
            code: Onglets.OMP,
            libelle: 'admin.parametres.formulaire.onglets.omp',
            url: 'Admin/Parametre/Formulaire/Omp'
        },
        {
            code: Onglets.OM,
            libelle: 'admin.parametres.formulaire.onglets.om',
            url: 'Admin/Parametre/Formulaire/Om'
        },
        {
            code: Onglets.DV,
            libelle: 'admin.parametres.formulaire.onglets.dv',
            url: 'Admin/Parametre/Formulaire/Voyage'
        },
        {
            code: Onglets.NDF,
            libelle: 'admin.parametres.formulaire.onglets.ndf',
            url: 'Admin/Parametre/Formulaire/Ndf'
        },
        {
            code: Onglets.AVANCE,
            libelle: 'admin.parametres.formulaire.onglets.avance',
            url: 'Admin/Parametre/Formulaire/Avance'
        },
        {
            code: Onglets.FACTURE,
            libelle: 'admin.parametres.formulaire.onglets.facture',
            url: 'Admin/Parametre/Formulaire/Facture'
        }
    ];

    /** Liste des différents onglets disponibles dans le menu paramètres */
    listeTabItems: Array<PageHeaderItem> = ParametreFormulaireComponent.listeOnglets;

    /** Onglet courant */
    selectedItem: PageHeaderItem;

    /** Index de l'onglet courant */
    selectedIndex: number;

    /**
     * Constructeur
     */
    constructor(
        private router: Router,
    ) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Détermination de l'onglet actif en fonction de l'URL actuelle
        this.initSelectedTab();
    }

    /**
     * Initialise l'onglet sélectionné en fonction de l'URL actuelle
     */
    private initSelectedTab(): void {
        //Utilisation de l'utilitaire TabUtils pour déterminer l'index de l'onglet actif
        this.selectedIndex = TabUtils.getSelectedTabIndexFromUrl(this.router,ParametreFormulaireComponent.listeOnglets);
        this.selectedItem = ParametreFormulaireComponent.listeOnglets[this.selectedIndex];
    }

    /**
     * Changement d'onglet
     *
     * @param selectedItem Onglet sélectionné
     */
    onSelectedItemChange(selectedItem: PageHeaderItem): void {
        if (!this.selectedItem) {
            this.selectedItem = selectedItem;
        }
        if (selectedItem?.code !== this.selectedItem?.code) {
            this.selectedItem = selectedItem;
            this.router.navigateByUrl(selectedItem.url);
        }
    }
}